export enum EvidenceTypeEnum {
    RECEIPT = 0,
    PICTURE = 1,
    SIGNATURE = 2,
    SCAN = 3
  }
